@if (hasArtifacts()) {
  <div class="flex">
    <app-button
      #trigger
      type="cancel"
      aria-haspopup="menu"
      [attr.aria-expanded]="isOpen()"
      [icon]="ICONS.download"
      [isForDropdown]="true"
      [active]="isOpen()"
      [tooltip]="'features.plan.jobs.artifacts.downloadButton' | translate"
      (clickEvent)="toggle()" />

    <app-dropdown
      [target]="trigger.elementRef.nativeElement"
      [template]="menu"
      [isOpen]="isOpen()"
      [onClose]="close"
      [closeOnClickOutside]="true"
      [closeOnEscape]="true" />
  </div>
}

<ng-template #menu>
  <div class="min-w-56" role="menu">
    <app-items-dropdown [items]="artifactItems()" />
  </div>
</ng-template>
